import { render, staticRenderFns } from "./AllAdminStudents.vue?vue&type=template&id=4473c1a0&scoped=true&"
import script from "./AllAdminStudents.vue?vue&type=script&lang=js&"
export * from "./AllAdminStudents.vue?vue&type=script&lang=js&"
import style0 from "./AllAdminStudents.vue?vue&type=style&index=0&id=4473c1a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4473c1a0",
  null
  
)

export default component.exports